<template>
  <el-aside
    class="main-aside primary-bg"
    :width="isCollapse ? '64px' : '240px'"
  >
    <el-menu
      :default-active="activeIndex"
      class="menu primary-bg"
      text-color="#fff"
      active-text-color="#fff"
      router
      :collapse="isCollapse"
    >
      <router-link to="/" class="logo-container">
        <div class="logo" v-if="isCollapse">
          <svg-img class-name="logo-icon" icon-class="logo" />
        </div>
        <div class="logo_title" v-else>
          <svg-img class-name="logo-title-icon" icon-class="logo-title" />
        </div>
      </router-link>
      <template v-for="(value, key) in permission_routers">
        <template v-if="!value.meta.hidden">
          <el-submenu
            :index="value.path == '/' ? value.redirect : value.path"
            v-if="value.children.length > 1 && !value.children[1].meta.hidden"
            :key="key"
          >
            <template slot="title">
              <svg-icon
                class-name="el-icon-location"
                :icon-class="value.meta.icon"
              />
              <span
                slot="title"
                :class="{ 'primary-bg': isCollapse }"
                class="menu-title"
                >{{ value.meta.title }}</span
              >
            </template>
            <template v-for="(item, index) in value.children">
              <el-menu-item
                v-if="!item.meta.hidden"
                :index="'/' + item.path"
                :key="index"
                :class="{ 'primary-bg': isCollapse }"
                style="padding-left: 65px"
                class="menu-title"
                >{{ item.meta.title }}</el-menu-item
              >
            </template>
          </el-submenu>
          <el-menu-item
            :index="value.path == '/' ? value.redirect : value.path"
            :key="key"
            v-else
          >
            <svg-icon
              class-name="el-icon-location"
              :icon-class="value.meta.icon"
            />
            <span slot="title" class="menu-title">{{
              value.children[0].meta.title
            }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </el-aside>
</template>

<script>
import { mapGetters } from "vuex";
import logo from "@/assets/images/logo.png";
import logoTitle from "@/assets/images/logo_title.png";

export default {
  name: "Sidebar",
  data() {
    return {
      logo: logo,
      logoTitle: logoTitle
    };
  },
  computed: {
    ...mapGetters(["permission_routers", "isCollapse"]),
    activeIndex() {
      //处理一些存在的子路由但是又不出现在右侧导航菜单的
      let act_path = this.$route.path;
      for (const item of this.$route.matched) {
        if (!item.meta.hidden) {
          if (item.path == "") {
            act_path = item.redirect;
          } else {
            act_path = item.path;
          }
        }
      }
      if (act_path.substr(act_path.length - 1, 1) == "/") {
        act_path = act_path.substr(0, act_path.length - 1);
      }
      return act_path;
    }
  },
  mounted() {
    console.log(this.permission_routers);
    if (document.documentElement.clientWidth < 800) {
      this.$store.commit("changeSidebar", true);
    }
    window.onresize = () => {
      if (document.documentElement.clientWidth < 800) {
        this.$store.commit("changeSidebar", true);
      }
    };
  },
  methods: {
    changeTheme(theme) {
      if (document.body.className) {
        theme = "";
      }
      this.$store.commit("setTheme", theme);
    },
    changeSidebar() {
      this.$store.commit("changeSidebar");
    }
  }
};
</script>

<style lang="scss">
.main-aside {
  overflow-x: hidden !important;
  transition: width 0.28s;
  .menu {
    border: unset !important;
    .el-menu {
      border: unset !important;
    }
    .menu-title {
      padding-left: 26px;
    }
    .el-icon-location {
      font-size: 24px;
    }
    .el-submenu__title i {
      color: #fff !important;
    }
  }
}
.logo-container {
  display: flex;
  align-items: center;
  width: 100%;
  height: 56px;
  position: relative;
  justify-content: center;
  .logo_title {
    height: 100%;
    left: 0;
    top: 5px;
    position: absolute;
    .logo-title-icon {
      height: 46px;
    }
  }
  .logo {
    width: 30px;
    height: 30px;
    color: #fff;
  }
}
</style>
